module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRTLoading.full_submission.includes(_vm.submission.id)),
      expression: "getRTLoading.full_submission.includes(submission.id)"
    }],
    staticClass: "pulsate"
  }, [_vm._v("\n    ...Loading data\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getRTLoading.full_submission.includes(_vm.submission.id)),
      expression: "!getRTLoading.full_submission.includes(submission.id)"
    }],
    staticClass: "py-8 rounded px-6 bg-gray-100"
  }, [(_vm.getCurrentRT.enable_grading) ? _c('div', {
    staticClass: "mb-3"
  }, [_c('PointsList', {
    staticClass: "px-4",
    attrs: {
      "rewards": _vm.getCurrentRT.points_settings.peer_rewards,
      "pointCap": Number(_vm.getCurrentRT.point_cap),
      "saving": _vm.savingAssessment,
      "editable": _vm.edit_assessment_feedback
    },
    on: {
      "saveAssessment": _vm.saveDraftAssessment
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_textbox),
      expression: "!show_textbox"
    }],
    staticClass: "start-sm col-xs center-xs",
    class: _vm.$route.query.submissionID === _vm.submission.id &&
      !_vm.$route.query.topLevelCommentID &&
      !_vm.$route.query.replyCommentID &&
      _vm.$route.query.assessment === true &&
      _vm.isFromNotificationState ?
      'border-2 border-pinky bg-pink-100' :
      'border-0'
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "white-spaced-text pt-3 px-2"
  }, [_vm._v("\n        " + _vm._s(_vm.getStudentSummary.evaluation.comment ||
    'There is currently no feedback here...') + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-between px-4 py-3"
  }, [_c('div', {
    staticClass: "w-full h-full focus-within:border-primary rounded border border-solid"
  }, [_c('textbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_textbox),
      expression: "show_textbox"
    }],
    key: ("assessment-textbox-" + (_vm.submission.id)),
    attrs: {
      "id": ("assessment-textbox-" + (_vm.submission.id)),
      "autoSave": false,
      "disabled": !_vm.hasTeacherPermissionsInCourse,
      "placeholder": ("Write feedback for " + (_vm.submission.user.name)),
      "theme": "feedback-theme",
      "showSubmitButton": false,
      "keepFocus": _vm.evaluation.comment !== _vm.submission.evaluation.comment
    },
    on: {
      "messageSent": _vm.submitAssessmentAndFeedback,
      "blur": _vm.saveDraftFeedback
    },
    model: {
      value: (_vm.evaluation.comment),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "comment", $$v)
      },
      expression: "evaluation.comment"
    }
  })], 1)]), _vm._v(" "), (
    _vm.hasTeacherPermissionsInCourse &&
    _vm.$route.name !== 'walkthrough.feed' &&
    _vm.show_textbox
  ) ? _c('div', {
    staticClass: "mx-5",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.collapsed_saved_feedback = !_vm.collapsed_saved_feedback;
        _vm.collapsed_suggested_feedback = true;
      }
    }
  }, [_c('span', {
    staticClass: "font-semibold text-xs"
  }, [_vm._v("\n            " + _vm._s(_vm.saved_feedback_collapse_message) + "\n          ")]), _vm._v(" "), (_vm.collapsed_saved_feedback) ? _c('i', {
    staticClass: "fas fa-arrow-down fa-xs"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up fa-xs"
  })]), _vm._v(" "), _c('div', {
    staticClass: "px-12"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.collapsed_suggested_feedback = !_vm.collapsed_suggested_feedback;
        _vm.collapsed_saved_feedback = true;
      }
    }
  }, [_c('span', {
    staticClass: "font-semibold text-xs"
  }, [_vm._v("\n              " + _vm._s(_vm.suggested_feedback_collapse_message) + "\n            ")]), _vm._v(" "), (_vm.collapsed_suggested_feedback) ? _c('i', {
    staticClass: "fas fa-arrow-down fa-xs"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up fa-xs"
  })])])]), _vm._v(" "), (!_vm.collapsed_saved_feedback) ? _c('div', {
    staticClass: "mt-4 w-full"
  }, [_c('div', {
    staticClass: "flex center items-center"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_vm._v("Saved Feedback")]), _vm._v(" "), _c('div', {
    staticClass: "mx-4 text-gray-400",
    on: {
      "click": _vm.refreshSavedFeedback
    }
  }, [_c('i', {
    staticClass: "fas fa-sync fa-xs",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.saved_feedback_to_display.length) ? _c('div', _vm._l((_vm.saved_feedback_to_display), function(feedback, index) {
    return _c('div', {
      key: index,
      staticClass: "flex center my-5 justify-between px-2"
    }, [_c('span', {
      staticClass: "font-medium"
    }, [_vm._v(_vm._s(feedback.text))]), _vm._v(" "), _c('div', {
      staticClass: "flex"
    }, [_c('button', {
      staticClass: "sample",
      on: {
        "click": function($event) {
          return _vm.selectSavedFeedback(feedback)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus-circle text-2xl ml-3 text-gray-400 mx-6"
    })]), _vm._v(" "), _c('div', {
      staticClass: "center items-center my-2"
    }, [_c('v-dropdown', {
      attrs: {
        "placement": "right"
      },
      scopedSlots: _vm._u([{
        key: "button",
        fn: function() {
          return [_c('i', {
            staticClass: "fas fa-ellipsis-v cursor-pointer text-gray-500 w-full flex items-center justify-end text-md"
          })]
        },
        proxy: true
      }, {
        key: "content",
        fn: function() {
          return [_c('ul', {
            staticClass: "w-28"
          }, [_c('li', {
            staticClass: "sample group px-3 py-2 rounded-t flex items-center w-full h-9 cursor-pointer hover:bg-gray-100",
            on: {
              "click": function($event) {
                return _vm.editSavedFeedback(feedback)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-edit",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "mx-3 text-xs"
          }, [_vm._v(" Edit")])]), _vm._v(" "), _c('li', {
            staticClass: "sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100 text-red-600",
            on: {
              "click": function($event) {
                return _vm.deleteSavedFeedback(feedback)
              }
            }
          }, [_c('i', {
            staticClass: "text-red-500 fas fa-trash-alt"
          }), _vm._v(" "), _c('span', {
            staticClass: "mx-3 text-xs px-1"
          }, [_vm._v(" Delete")])])])]
        },
        proxy: true
      }], null, true)
    })], 1)])])
  }), 0) : _c('div', [_c('div', {
    staticClass: "text-left my-5"
  }, [_vm._v("\n            You have no saved feedback templates. Create a new template or\n            import some from an existing course.\n          ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "sample mr-2 px-5 py-2 cursor-pointer text-xs font-semibold text-white bg-blueGray-500 rounded",
    on: {
      "click": _vm.newSavedFeedback
    }
  }, [_c('span', [_vm._v("New")])]), _vm._v(" "), _c('button', {
    staticClass: "sample mr-2 px-5 py-2 cursor-pointer text-xs font-semibold text-white bg-blueGray-500 rounded",
    on: {
      "click": _vm.showImportFeedback
    }
  }, [_c('span', [_vm._v("Import")])])])]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.collapsed_suggested_feedback) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "flex font-semibold"
  }, [_vm._v("\n            Suggested Feedback\n            "), _c('div', {
    staticClass: "mx-4 text-gray-400",
    on: {
      "click": _vm.refreshAutomatedFeedback
    }
  }, [_c('i', {
    staticClass: "fas fa-sync fa-xs",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _vm._l((_vm.automated_feedback_to_display), function(feedback, index) {
    return _c('div', {
      key: index,
      staticClass: "flex center my-5 justify-between"
    }, [_c('div', {}, [_c('span', {
      staticClass: "font-medium"
    }, [_vm._v(_vm._s(feedback.text))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Tooltip', {
      attrs: {
        "text": feedback.explanation,
        "styleTooltip": "top-0 -mt-1 left-full ml-2",
        "positionTooltip": "absolute"
      }
    }, [_c('button', {
      staticClass: "text-pinky"
    }, [_vm._v("Why this suggestion?")])])], 1), _vm._v(" "), _c('div', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.selectAutomatedFeedback(feedback)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus-circle text-2xl ml-3 text-gray-400 mx-6"
    })])])])
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex items-center p-4 cursor-default"
  }, [_c('div', {
    staticClass: "mr-5 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.collapsed_comments_made = !_vm.collapsed_comments_made
      }
    }
  }, [_c('span', {
    staticClass: "font-semibold text-base"
  }, [_vm._v("\n          " + _vm._s(_vm.getStudentSummary.my_comments.length === 1 ?
    'Comment Made' :
    'Comments Made') + "\n          (" + _vm._s(_vm.getStudentSummary.my_comments.length) + ")\n        ")]), _vm._v(" "), (_vm.collapsed_comments_made) ? _c('i', {
    staticClass: "fas fa-arrow-down fa-xs"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up fa-xs"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400"
  }, [_vm._v("\n        Class Median =\n        " + _vm._s(_vm.getStudentSummary.diversity_info.median_comments_submission) + "\n      ")])]), _vm._v(" "), (!_vm.collapsed_comments_made) ? _c('comment-summary', {
    staticClass: "px-4"
  }) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex justify-end px-4"
  }, [(_vm.show_textbox) ? _c('button', {
    staticClass: "sample py-2 px-5 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": _vm.submitAssessmentAndFeedback
    }
  }, [_vm._v("\n        " + _vm._s(_vm.hasAssessments ? 'Update' : 'Send') + "\n      ")]) : _c('button', {
    staticClass: "sample py-2 px-5 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showTextbox;
        _vm.edit_assessment_feedback = true;
      }
    }
  }, [_vm._v("\n        Edit\n      ")])]) : _vm._e()], 1), _vm._v(" "), (_vm.show_saved_feedback_modal) ? _c('NewFeedbackTemplateModal', {
    attrs: {
      "typeRoundtable": "online",
      "feedbackID": _vm.feedback_id,
      "feedbackContent": _vm.feedback_content,
      "editingFeedback": _vm.set_edit_saved_feedback
    },
    on: {
      "close": function($event) {
        return _vm.closeFeedbackModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_import_feedback_modal) ? _c('ImportFeedbackTemplatesModal', {
    attrs: {
      "typeRoundtable": "online"
    },
    on: {
      "close": function($event) {
        _vm.show_import_feedback_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_confirm_delete_feedback) ? _c('dialog-delete-confirm', {
    attrs: {
      "header": 'Delete this saved feedback template',
      "subHeader": 'It will be permanently removed from this course.'
    },
    on: {
      "close": function($event) {
        _vm.show_confirm_delete_feedback = false
      },
      "actionConfirmed": _vm.confirmDeleteSavedFeedback
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-margin middle-xs flex items-center justify-center"
  }, [_c('h5', {
    staticClass: "pl-subheading assessment-title text-center"
  }, [_vm._v("\n          Private Feedback\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-27bcf50f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/assessmentTab.vue
// module id = 1206
// module chunks = 61